import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

let app, auth, googleProvider, db, analytics, perf;

try {
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  };

  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  // login_hint is optional and MUST come from env. A hardcoded address here is
  // compiled into the public JS bundle and readable by every visitor.
  const loginHint = import.meta.env.VITE_LOGIN_HINT;
  googleProvider.setCustomParameters({
    prompt: 'select_account',
    ...(loginHint ? { login_hint: loginHint } : {}),
  });
  db = getFirestore(app);
  
  if (typeof window !== 'undefined') {
    try {
      analytics = getAnalytics(app);
      perf = getPerformance(app);
    } catch (e) {
      console.warn("Firebase Analytics/Perf failed to initialize (ad-blocker likely)", e);
    }
  }
} catch (err) {
  console.warn("Firebase Auth failed to initialize (likely Safari Strict Tracking Prevention). Using Mock Auth for local testing.");
  app = {};
  googleProvider = {};
  auth = {
    onAuthStateChanged: (cb) => {
      // Auto-login as the mock user so testing can continue
      setTimeout(() => cb({ uid: "ME", email: "test@test.com", displayName: "Safari User" }), 100);
      return () => {};
    }
  };
}

export { app, auth, googleProvider, db, analytics, perf };
